module.exports = __webpack_public_path__ + "static/media/CD.cd99fa37.svg";